

import { RouteName } from '@/router/routes';
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

// import InfoApi from '../api/infos';

export default Vue.extend({
  name: 'ErrorLogout',
  props: {
    cause: {
      type: String,
      default: null
    }
  },
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapGetters({ user: 'user/user' }),
    appName ():string|undefined {
      return window.PROPERTIES.get('app.name') as any;
    },

    libelleErreur ():string|null {
      switch (this.cause) {
        case 'TIERS_NON_RECONNU':
          return 'Numéro de tiers non reconnu';
        default:
          return null;
      }
    },
    texteDetails ():string {
      switch (this.cause) {
        case 'NON_ABONNE':
          return 'Vous n’avez pas les autorisations requises pour accéder à cette page.<br/>' +
            'Veuillez contacter votre maison de région.';

        case 'INCIDENT_PAIEMENT':
          return `Un incident de paiement en cours vous empêche d’accéder au site des ${this.appName}.<br>` +
                        `Pour toute information sur cet incident, veuillez contacter le responsable de comptes de votre maison de région.`;
        default:
          return 'Pour les demandes d\'accès salarié à cet outil, merci de contacter le poste de travail, en envoyant un mail à : postedetravail.informatique@agrial.com<br>';
      }
    },
    afficherBtnMonAgrial ():boolean {
      switch (this.cause) {
        case 'ADHERENT_VGM' :
          return false;
        default:
          return true;
      }
    }
  },
  created () {
    for (const role of this.user.roles as string[]) {
      if (role.startsWith('ACCESS_ERROR_')) {
        this.$router.replace({ name: RouteName.LOGOUT_ERROR, query: { cause: role.replace('ACCESS_ERROR_', '') } });
        break;
      }
    }
  },
  methods: {
    ...mapActions({ sessionLogout: 'session/logout' }),
    logout () {
      this.sessionLogout().finally(() => {
        this.$store.dispatch('reset');
        this.$router.push({ name: RouteName.LOGIN });
      });
    },
    goMonAgrial () {
      const urlPortail = window.PROPERTIES.get('agrial.portail.url');
      if (urlPortail) {
        window.location.href = urlPortail as any;
      }
    }

  }
});

